import { __decorate } from "tslib";
// Core
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
// Extends
// Children
import CloseIcon from '@/components/v3/CloseIcon.vue';
// Models / Helpers
// Queries / Mutations
/**
 * Facebook Post Thumbnail cards
 * @author Jan Canicon <jan@gorated.ph>
 *                     <jancanicon.work@gmail.com>
 * @since Version {2.21.0}
 *
 * Docs: https://gorated.atlassian.net/wiki/spaces/DMDS/pages/1856045301/Facebook+Post+Thumb
 */
let FacebookPostThumb = class FacebookPostThumb extends Vue {
    get captionClass() {
        return {
            'detailed my-2': this.detailed,
            'summarized mb-0': !this.detailed,
            'clamp-5': !this.post.full_picture,
            'clamp-2': this.post.full_picture,
        };
    }
    humanReadableDate(date) {
        return moment(date).fromNow();
    }
};
__decorate([
    Prop({ type: Object, default: null })
], FacebookPostThumb.prototype, "post", void 0);
__decorate([
    Prop({ type: Boolean, default: null })
], FacebookPostThumb.prototype, "closeIcon", void 0);
__decorate([
    Prop({ type: Boolean, default: null })
], FacebookPostThumb.prototype, "detailed", void 0);
__decorate([
    Prop({ type: Boolean, default: null })
], FacebookPostThumb.prototype, "clickable", void 0);
__decorate([
    Prop({ type: String, default: '' })
], FacebookPostThumb.prototype, "width", void 0);
FacebookPostThumb = __decorate([
    Component({
        components: {
            CloseIcon,
        },
    })
], FacebookPostThumb);
export default FacebookPostThumb;
